// utils/websocket.js
class Socket {
  /**
   * @description: 初始化配置
   * @param {Object} options 配置对象
   *   url: WebSocket连接地址
   *   heartTime: 心跳时间间隔(毫秒)
   *   heartMsg: 心跳消息内容
   *   isReconnect: 是否自动重连
   *   reconnectTime: 重连时间间隔(毫秒)
   *   reconnectCount: 重连次数 -1 则不限制
   *   openCb: 连接成功的回调
   *   closeCb: 连接关闭的回调
   *   messageCb: 收到消息的回调
   *   errorCb: 连接错误的回调
   */
  constructor(options = {}) {
    // 默认配置
    const defaultOptions = {
      heartTime: 5000, // 5秒心跳
      heartMsg: "ping", // 心跳消息
      isReconnect: true, // 是否自动重连
      reconnectTime: 5000, // 重连间隔
      reconnectCount: -1, // 重连次数，-1表示不限次数
    };

    // 合并配置
    this.options = Object.assign(defaultOptions, options);

    // WebSocket实例
    this.ws = null;

    // 重连次数计数器
    this.reconnectCurrent = 0;

    // 心跳计时器
    this.heartTimer = null;

    // 重连计时器
    this.reconnectTimer = null;

    // 初始化
    this.init();
  }

  // 初始化WebSocket
  init() {
    // console.log("asdf");
    if (!this.options.url) {
      throw new Error("WebSocket url is required");
    }

    // 清除所有计时器
    this.clearAllTimer();

    // 创建WebSocket实例
    this.ws = new WebSocket(this.options.url);
    // console.log("this.ws", this.ws);
    // 绑定事件
    this.ws.onopen = (e) => this.onOpen(e);
    this.ws.onclose = (e) => this.onClose(e);
    this.ws.onmessage = (e) => this.onMessage(e);
    this.ws.onerror = (e) => this.onError(e);
  }

  // 连接成功
  onOpen(e) {
    // console.log("WebSocket连接成功", e);

    // 开启心跳
    this.heartCheck();

    // 执行回调
    if (typeof this.options.openCb === "function") {
      this.options.openCb(e);
    }
  }

  // 连接关闭
  onClose(e) {
    // console.log("WebSocket连接关闭", e);

    // 清除心跳
    clearInterval(this.heartTimer);

    // 执行回调
    if (typeof this.options.closeCb === "function") {
      this.options.closeCb(e);
    }

    // 重连
    if (this.options.isReconnect) {
      this.reconnect();
    }
  }

  // 收到消息
  onMessage(e) {
    // 收到任何消息都重置心跳（因为有些后端会返回pong）
    this.heartCheck();

    // 执行回调
    if (typeof this.options.messageCb === "function") {
      this.options.messageCb(e.data);
    }
  }

  // 连接错误
  onError(e) {
    console.error("WebSocket发生错误", e);

    // 执行回调
    if (typeof this.options.errorCb === "function") {
      this.options.errorCb(e);
    }

    // 重连
    if (this.options.isReconnect) {
      this.reconnect();
    }
  }

  // 心跳检测
  heartCheck() {
    // 清除旧的心跳
    clearInterval(this.heartTimer);

    // 发送心跳
    this.heartTimer = setInterval(() => {
      if (this.ws.readyState === WebSocket.OPEN) {
        const heartBeatData = {
          type: 10,
          data: null,
        };
        this.ws.send(JSON.stringify(heartBeatData));
      } else {
        clearInterval(this.heartTimer);
      }
    }, this.options.heartTime);
  }

  // 重连
  reconnect() {
    // 达到重连次数限制则不再重连
    if (
      this.options.reconnectCount > 0 &&
      this.reconnectCurrent >= this.options.reconnectCount
    ) {
      return;
    }

    // 清除重连计时器
    clearTimeout(this.reconnectTimer);

    // 增加重连次数
    this.reconnectCurrent++;

    // console.log(`正在尝试第${this.reconnectCurrent}次重连...`);

    // 延迟重连
    this.reconnectTimer = setTimeout(() => {
      this.init();
    }, this.options.reconnectTime);
  }

  // 发送消息
  send(data) {
    if (this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(data));
    } else {
      console.error("WebSocket连接未就绪，无法发送消息");
    }
  }

  // 关闭连接
  close() {
    this.options.isReconnect = false;
    this.ws.close();
  }

  // 清除所有计时器
  clearAllTimer() {
    clearInterval(this.heartTimer);
    clearTimeout(this.reconnectTimer);
  }
}

export default Socket;
